import { useState, useEffect } from 'react';
import { GeoThreat } from '../types/disaster';
import { NewsDataIODisasterExtractor } from '../services/newsApiExtractor';

export const useDisasterFeed = (apiKey: string) => {
  const [disasters, setDisasters] = useState<GeoThreat[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const extractor = new NewsDataIODisasterExtractor(apiKey);

  const fetchDisasters = async () => {
    try {
      setLoading(true);
      setError(null);
      const extractedDisasters = await extractor.extractDisasters();
      setDisasters(extractedDisasters);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch disasters');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDisasters();
    
    // Set up auto-refresh every 10 minutes
    const interval = setInterval(fetchDisasters, 10 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, [apiKey]);

  return { disasters, loading, error, refetch: fetchDisasters };
};